<template>
    <div>
        <div class="accountsBox">
            <div>
                <div class="mobileBox">
                    <p>手机号</p>
                    <span>17333972615</span>
                    <div class="modify">

                    </div>
                </div>
            </div>
            <div style="margin: 15px 0px">
                <div class="passwordBox">
                    <p>登录密码</p>
                    <span>******</span>
                    <div class="modifyBox">
                        修改
                    </div>
                </div>
            </div>
            <div>
                <div class="mailbox">
                    <p>邮箱</p>
                    <span>2388851214@qq.com</span>
                    <div class="modifyBox">
                        修改
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'accounts'
    };
</script>

<style scoped>
    .accountsBox{
        padding: 30px;
        border-radius: 5px;
        background-color: #fff;
        margin: 10px;
    }
    .mobileBox,
    .passwordBox,
    .mailbox{
        display: flex;
        width: 40%;
        align-items: center;
        justify-content: space-between;
    }
    .modify{
        width: 100px;
        height: 40px;
    }
    .modifyBox{
        width: 100px;
        height: 40px;
        border: 1px solid #0051b4;
        text-align: center;
        line-height: 40px;
        color: #0051b4;
        border-radius: 5px;
        cursor: pointer;
    }
</style>
